import type { CSSProperties } from 'react'

/** Figma dimensions & colors for offer-detail kanban columns (step names unchanged). */

export const FIGMA_KANBAN_COLUMN = {
  width: 232,
  height: 372,
  borderRadius: 6,
  borderColor: '#D8D8D8',
  headerHeight: 56,
  headerPadding: 16,
  footerHeight: 45,
  footerPaddingY: 12,
  footerPaddingX: 16,
  footerGap: 10,
  footerBg: '#F2F2F7',
  candidateRowHeight: 42,
  candidateRowPaddingX: 16,
  candidateRowPaddingY: 12,
  candidateRowGap: 10,
} as const

export type FigmaColumnTheme = {
  headerBg: string
  accent: string
  titleClass: string
  titleStyle?: CSSProperties
  isOverClass: string
}

/** First column — Candidats (order 1) */
export const FIGMA_COLUMN_1: FigmaColumnTheme = {
  headerBg: '#27C8401A',
  accent: '#34C759',
  titleClass:
    "font-['Montserrat',sans-serif] text-base font-bold leading-[1.5] tracking-[0.01em] text-[#34C759]",
  isOverClass: 'bg-[#27C8400D] dark:bg-green-900/10',
}

/** Second column — Shortlist IA (order 2) */
export const FIGMA_COLUMN_2: FigmaColumnTheme & { footerTextClass: string } = {
  headerBg: '#00C0E81A',
  accent: '#00C0E8',
  titleClass:
    "font-['Montserrat',sans-serif] text-base font-bold leading-[1.5] tracking-[0.01em] text-[#00C0E8]",
  isOverClass: 'bg-[#00C0E80D] dark:bg-cyan-900/10',
  footerTextClass:
    "font-['Montserrat',sans-serif] text-sm font-medium leading-[1.5] tracking-[0.01em] text-[#232323] dark:text-foreground",
}

export const FIGMA_COLUMN_1_FOOTER_ORANGE = '#FF9500'

const DEFAULT_STEP_HEX = '#3B82F6'

function normalizeHex(hex: string): string {
  const trimmed = (hex || '').trim()
  if (!trimmed) return DEFAULT_STEP_HEX
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`
}

/** Derive Figma header/badge colors from hiring step hex (columns 3+). */
export function getFigmaThemeFromStepColor(hexColor: string): FigmaColumnTheme {
  const accent = normalizeHex(hexColor)
  const headerBg = `${accent}1A`
  return {
    headerBg,
    accent,
    titleClass:
      "font-['Montserrat',sans-serif] text-base font-bold leading-[1.5] tracking-[0.01em]",
    titleStyle: { color: accent, fontWeight: 700 },
    isOverClass: 'bg-black/[0.03] dark:bg-white/5',
  }
}
